import React, { useEffect } from "react";
import ImageLoading from "../../components/ImageLoading";
import SuccessImage from "../../images/sidebar/SuccessImage";
import FailImage from "../../images/FailImage";

function RefreshFundsModal({
  loading,
  setShowRefreshModal,
  refreshStatus,
  message,
}) {
  useEffect(() => {
    if (!loading) {
      setTimeout(() => {
        setShowRefreshModal(false);
      }, 3000);
    }
  }, [loading]);
  return (
    <div className="overlay z-50">
      <div
        className={`modal !w-[400px]  !justify-normal  relative !p-0 !text-left !items-center !h-[130px] `}
      >
        {loading && (
          <div className=" w-full h-full flex justify-center items-center">
            <ImageLoading />
          </div>
        )}
        {!loading && (
          <div className=" w-full h-full flex justify-center flex-col items-center">
            {/* <Lottie
              animationData={animation}
              options={defaultOptions}
              height={70}
              width={70}
            /> */}
            {refreshStatus ? <SuccessImage /> : <FailImage />}

            <p className=" font-bold text-sm mt-2">
              {message !== "" && message}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default RefreshFundsModal;
